export function buildWorkspaceScalesListQueryV1(workspaceId: number)
{
	return {
		'$type': 'TCh.Domain.Scales.Queries.WorkspaceScalesListQueryV1, TCh.Domain.Scales',
		'WorkspaceId': workspaceId,
	}
}